import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "menu_list" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", { class: "menu_title" }, "플랫폼", -1)
const _hoisted_3 = ["onClick"]
const _hoisted_4 = {
  key: 0,
  class: "menu_icon"
}
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "menu_name" }
const _hoisted_7 = { class: "menu_list" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", { class: "menu_title" }, "왓쳐봇", -1)
const _hoisted_9 = ["onClick"]
const _hoisted_10 = {
  key: 0,
  class: "menu_icon"
}
const _hoisted_11 = ["src"]
const _hoisted_12 = { class: "menu_name" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["menu_wrap", { flex_center: $setup.user.userInfo.clfCd !== 99 }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.platform.list, (item) => {
        return (_openBlock(), _createElementBlock(_Fragment, null, [
          (!item.isAdmin || (item.isAdmin && $setup.user.userInfo.clfCd === 99))
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: _normalizeClass(["menu_tab shadow", {
                        active: $setup.global.selectMenu === item.idx,
                        small: $setup.global.selectMenu !== 0 && $setup.global.selectMenu !== 5,
                        disabled: item.isDisabled,
                    }]),
                onClick: ($event: any) => ($setup.movePage(item))
              }, [
                ($setup.global.selectMenu === 0 || $setup.global.selectMenu === 5)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                      _createElementVNode("img", {
                        src: $setup.global.selectMenu === item.idx ? item.icon.white : item.icon.blue
                      }, null, 8, _hoisted_5)
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_6, _toDisplayString(item.title), 1)
              ], 10, _hoisted_3))
            : _createCommentVNode("", true)
        ], 64))
      }), 256))
    ]),
    _createElementVNode("div", _hoisted_7, [
      _hoisted_8,
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.watcherBot.list, (item) => {
        return (_openBlock(), _createElementBlock(_Fragment, null, [
          (!item.isAdmin || (item.isAdmin && $setup.user.userInfo.clfCd === 99))
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: _normalizeClass(["menu_tab shadow", {
                        active: $setup.global.selectMenu === item.idx,
                        small: $setup.global.selectMenu !== 0 && $setup.global.selectMenu !== 5,
                        disabled: item.isDisabled,
                    }]),
                onClick: ($event: any) => ($setup.movePage(item))
              }, [
                ($setup.global.selectMenu === 0 || $setup.global.selectMenu === 5)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                      _createElementVNode("img", {
                        src: $setup.global.selectMenu === item.idx ? item.icon.white : item.icon.blue
                      }, null, 8, _hoisted_11)
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_12, _toDisplayString(item.title), 1)
              ], 10, _hoisted_9))
            : _createCommentVNode("", true)
        ], 64))
      }), 256))
    ])
  ], 2))
}